module.exports = __webpack_public_path__ + "media/images/spbn01-493b591f052f41c7cd81e9de4592bb29.png";